import { useTranslation } from 'react-i18next';
import TypeCustomMultiSelect from '../../../form/form-fields/TypeCustomMultiSelect';

export const MatchingPropLeadFieldSelect = ({ property, onChange }) => {
  const { t } = useTranslation();

  const valueField = {
    label: property.label,
    key: 'minValue',
    options: property.options || [],
    noUnselect: true,
  };

  function handleUpdate(key, value) {
    const newProp = { ...property, [key]: value };
    onChange(newProp);
  }

  return (
    <TypeCustomMultiSelect
      size="small"
      field={valueField}
      dataCollection={property}
      startDataCollection={property}
      updateValidationOnChange={handleUpdate}
    />
  );
};
